import BaseCtrl from 'edge/platform/base/BaseCtrl';
import FlowFactory from 'edge/platform/flow/FlowFactory';
import actionStatusMessages from 'edge/platform/flow/angularhelpers/ActionStatusMessages';
import cancelConfirmation from 'edge/platform/flow/angularhelpers/CancelConfirmation';
import compositeFlowConfig from 'integration/endorsement/config/CompositeFlowConfig';
import PolicyChange from 'edge/endorsement/common/models/PolicyChange';
import endorsementStepCheckFn from 'edge/endorsement/common/config/EndorsementJumpToStepCheck';

var fn = function fn($scope, $state, $stateParams, EndorsementService, $q, ViewModelService, ModalService, StateUtils, AvailabilityService, EventHub) {
    var ctrl = Object.create(BaseCtrl);
    var PRE_SUBFLOW_STATES = ['PolicyList', 'EffectiveDate', 'WhatsNext'];
    var showHistoryDeregFunction = void 0;

    // Not using lambda's here to make controller api easier to read at a glance
    ctrl.init = init;
    ctrl.isVisible = isVisible;
    ctrl.getTileState = getTileState;
    ctrl.goNext = goNext;
    ctrl.reset = reset;
    ctrl.goToStep = goToStep;
    ctrl.bind = bind;
    ctrl.withdraw = withdraw;
    ctrl.onError = contactAgent;
    ctrl.exitWizard = exitWizard;
    ctrl.cancel = cancel;
    ctrl.canDisplayQuoteBtn = canDisplayQuoteBtn;
    ctrl.canEditState = canEditState;

    return ctrl.create($scope);

    function init() {
        $scope.selectedPolicyNumberParam = $stateParams.selectedPolicyNumber;

        if ($stateParams.day && $stateParams.month && $stateParams.year) {
            $scope.selectedDate = {
                day: $stateParams.day,
                month: $stateParams.month,
                year: $stateParams.year
            };
        }

        // Flag to used to determine whether the user has transitioned to the subflow
        $scope.pastOrInSubflow = false;
        $scope.historyIsHiddenOnMobile = true;
        $scope.flow = createNewWizardFlow();
        $scope.flow.alternativeJumpToStepCheck = endorsementStepCheckFn;
        StateUtils.activeDataForState().flowModel = $scope.flow;
        if (!showHistoryDeregFunction) {
            showHistoryDeregFunction = $scope.$root.$on('endorsementShowHistory', function () {
                $scope.historyIsHiddenOnMobile = !$scope.historyIsHiddenOnMobile;
            });
            $scope.$on('$destroy', function () {
                showHistoryDeregFunction();
            });
        }

        var onWizardStateTranition = function onWizardStateTranition(actionHandler, transitionPromise) {
            $scope.wizardTransitionPromise = transitionPromise;
            $scope.wizardTransitionPromise.then(function () {
                $scope.promiseResolved = true;
            });
            $scope.promiseResolved = false;
        };
        StateUtils.subscribeToStateTransitions(onWizardStateTranition);
        $scope.$on('$destroy', function () {
            return StateUtils.unsubscribeFromStateTransitions(onWizardStateTranition);
        });
    }

    /**
     * Creates a new wizard flow
     * @returns {*} new wizard Flow
     */
    function createNewWizardFlow() {

        var modalBehavior = {
            actionStatusInfo: actionStatusMessages(ModalService),
            snapshotResetConfirmation: ignoreReset,
            cancelConfirmation: cancelConfirmation(ModalService, StateUtils)
        };

        // Hide next panel
        $scope.pastOrInSubflow = false;
        var partiallyAppliedFlowFactory = FlowFactory.get($q, EventHub, [function () {
            return wizardListener;
        }], modalBehavior, StateUtils);
        var compositeFlow = compositeFlowConfig($q, EndorsementService, AvailabilityService);
        var flowFactory = partiallyAppliedFlowFactory(compositeFlow);

        var policyChange = $scope.selectedPolicyNumberParam ? {
            selectedPolicyNumber: $scope.selectedPolicyNumberParam,
            effectiveDate: $scope.selectedDate
        } : {};

        return flowFactory.start(policyChange);

        /**
         *  wizard api flow transtion listener
         * @param {Object} model - model passed along in wizard flow transition
         * @param {Object} from - previous state
         * @param {Object} next - next state (ignored)
         */
        function wizardListener(model, from, next) {
            if (next.name !== 'endorsementError' && from.name !== 'cancel') {
                $scope.pastOrInSubflow = $scope.pastOrInSubflow || goingToSubFlow(from.name, next.name);
                $scope.wizard = {
                    'state': next,
                    'model': model
                };

                if (model.policyChange) {
                    $scope.wizard.viewModel = ViewModelService.create(model.policyChange, 'pc', 'edge.capabilities.policychange.dto.PolicyChangeDataDTO');
                }
                if ($scope.wizard.state.name === 'PolicyList') {
                    $scope.wizard.model.policyChange = new PolicyChange();
                }
            } else if (from.name === 'cancel') {
                // Reset policy change when coming from the cancel state
                $scope.wizard = {
                    'state': next,
                    'model': {
                        policyChange: new PolicyChange()
                    }
                };
            } else if (next.name === 'endorsementError') {
                contactAgent();
            }
        }

        /**
         * Determine if there is a transition from the common flow to the LOB specific flow
         * @param {Object} fromState - state transitioning from
         * @param {Object} nextState - state transitioning to
         * @returns {boolean}
         */
        function goingToSubFlow(fromState, nextState) {
            var leavingWhatsNext = fromState === 'WhatsNext';
            var notGoingBack = !PRE_SUBFLOW_STATES.some(function (state) {
                return nextState === state;
            });
            return leavingWhatsNext && notGoingBack;
        }

        /**
         * Function pass on model when because reset is ignored.
         * @param {Object} model
         * @returns {Promise} resolves to 'confirmed' if confirmed, else resolves to 'cancelled'
         */
        function ignoreReset(model) {
            return $q.resolve(model);
        }
    }

    /**
     * Determine whether a state is in the wizard flow and has not been visited yet
     * @param {String} state to check
     * @returns {boolean}
     */
    function isVisible(state) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = $scope.flow.steps[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var currentState = _step.value;

                // State found before current wizard state found
                if (currentState.name === state) {
                    return true;
                }
                // Otherwise shortcut if we find the current active wizard state before the one being searched
                if (currentState === $scope.wizard.state) {
                    return false;
                }
            }
            // Not in the flow, default to false
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return false;
    }

    /**
     * Gets a states visual representation for a named state in the wizard flow
     * @param {String} tileStateName - The name of the state
     * @returns {string} - Returns the strings 'full' or 'tile' to represent the states visual representation
     */
    function getTileState(tileStateName) {
        if (!$scope.wizard) {
            return 'tile';
        }

        return $scope.wizard.state.name === tileStateName ? 'full' : 'tile';
    }

    /**
     * Attempts to transtion to the next step in the wizard api
     * @param {*} args
     */
    function goNext(args) {
        $scope.flow.next($scope.wizard.model, args);
    }

    /**
     * Reset the wizard to the initial state.
     */
    function reset() {
        var cancelPromise = $scope.flow.cancel($scope.wizard.model.policyChange);
        cancelPromise.then(function () {
            $scope.pastOrInSubflow = false;
            $scope.historyIsHiddenOnMobile = true;
            $state.go('policies.detail.summary', {
                'policyNumber': $scope.wizard.model.policyChange.policyNumber
            });
        });
    }

    function canDisplayQuoteBtn() {
        return (isVisible('HOPreQuote') || isVisible('PAPreQuote')) && (getTileState('HOPreQuote') === 'full' || getTileState('PAPreQuote') === 'full');
    }

    /**
     * Attempts to transition wizard to named step in Endorsment flow
     * @param {String} stepName - named step in wizard API
     * @returns {*}
     */
    function goToStep(stepName) {
        // Can only go back to a previous step as along as the user has not reached the finished step
        if (canJumpFromThisStep(stepName)) {
            $scope.flow.jumpToStep(stepName, $scope.wizard.model);
            return true;
        }

        function canJumpFromThisStep(step) {
            /*  Can jump back if still in first flow and transition is within this flow, or if in the lob flow and
             transitioning to a step within that flow
             */
            var notGoingToCurrentStep = step !== $scope.wizard.state.name;
            var onTopRowAndGoingToPast = !$scope.pastOrInSubflow && PRE_SUBFLOW_STATES.includes(step);
            var onBottomAndNotGoingToPast = $scope.pastOrInSubflow && !PRE_SUBFLOW_STATES.includes(step);
            return notGoingToCurrentStep && (onTopRowAndGoingToPast || onBottomAndNotGoingToPast);
        }
    }

    function cancel() {
        $state.go('policies.detail.summary', {
            'policyNumber': $scope.wizard.model.policyChange.policyNumber
        });
    }

    /**
     * Withdraws the policy changes.
     */
    function withdraw() {
        var withdrawModalPromise = ModalService.showWarning('gateway.views.endorsement.Are you sure you want to withdraw?', 'gateway.views.endorsement.Are you sure you want to withdraw this policy change').result;
        withdrawModalPromise.then(function () {
            $scope.withdrawPolicyChangePromise = EndorsementService.withdrawEndorsement($scope.wizard.model.policyChange.jobID).then(function () {
                goToEndorcementDetailPage();
            }, function () {
                ModalService.showError('gateway.views.modal.Error', 'gateway.views.endorsement.Unable to withdraw this policy change');
            });
        });
    }

    /**
     * Saves the current policy change.
     */
    function exitWizard() {
        goToEndorcementDetailPage();
    }

    /**
     * Binds a quoted policy change.
     */
    function bind() {
        $state.go('payment', {
            policyChange: $scope.wizard.model.policyChange
        });
    }

    /**
     * Redirect to the contact Agent page when an error occurs.
     */
    function contactAgent() {
        var stateParams = void 0;
        if (angular.isDefined($scope.wizard) && $scope.wizard.model && $scope.wizard.model.selectedPolicyNumber) {
            stateParams = { policyNumber: $scope.wizard.model.selectedPolicyNumber };
        } else {
            stateParams = { policyNumber: $stateParams.selectedPolicyNumber };
        }

        $state.go('endorsContactAgent', stateParams);
    }

    function goToEndorcementDetailPage() {
        $state.go('endorsements.detail.summary', {
            'policyChangeNumber': $scope.wizard.model.policyChange.jobID
        });
    }

    /**
     * The user can edit a state if they have reached the subflow of endorsements,
     * @param {String} state
     * @returns {boolean|*}
     */
    function canEditState(state) {
        var isAValidPreviousStep = !!$scope.flow.visitedSteps.find(function (step) {
            return step.name === state;
        });
        var loaderNotActive = $scope.promiseResolved;
        return $scope.pastOrInSubflow && isAValidPreviousStep && loaderNotActive;
    }
};

fn.$inject = ['$scope', '$state', '$stateParams', 'endorsement.EndorsementService', '$q', 'ViewModelService', 'ModalService', 'StateUtils', 'AvailabilityService', 'EventHub'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/endorsement/common/controllers/EndorsementEntryCtrl.js
// module id = 1772
// module chunks = 0